import { createTafsirAyahTemplate } from '../../../views/templates/template-creator';

const TafsirHandler = {
  init(surah, btnTafsirAyah) {
    const srcTafsir = {
      quraish: 'Tafsir Quraish',
      jalalayn: 'Tafsir Jalalayn',
    };
    const srcKemenag = {
      short: 'Tafsir Kemenag (singkat)',
      long: 'Tafsir Kemenag (lengkap)',
    };
    this._tafsirListener({
      surah, btnTafsirAyah, srcTafsir, srcKemenag,
    });
  },

  _tafsirListener({
    surah, btnTafsirAyah, srcTafsir, srcKemenag,
  }) {
    btnTafsirAyah.forEach((btn) => {
      const numAyahQuran = btn.getAttribute('numAyahQuran');
      const numAyahSurah = btn.getAttribute('numAyahSurah');
      const tafsirContainer = document.querySelector(`#tafsir-${numAyahQuran}`);
      const { tafsir } = surah.data.ayahs[numAyahSurah - 1];
      btn.addEventListener('click', () => this._showTafsir({
        btn, srcTafsir, srcKemenag, tafsirContainer, tafsir,
      }));
    });
  },

  _showTafsir({
    btn, srcTafsir, srcKemenag, tafsirContainer, tafsir,
  }) {
    tafsirContainer.classList.toggle('hidden');
    btn.classList.toggle('border-b');
    const isShowTafsir = tafsirContainer.classList.contains('hidden');
    if (!isShowTafsir) {
      this._insertTafsir({
        srcTafsir, srcKemenag, tafsirContainer, tafsir,
      });
      tafsirContainer.firstElementChild.setAttribute('open', '');
    } else {
      tafsirContainer.innerHTML = '';
    }
  },

  _insertTafsir({
    srcTafsir, srcKemenag, tafsirContainer, tafsir,
  }) {
    Object.keys(tafsir).forEach((key) => {
      if (key === 'kemenag') {
        Object.keys(tafsir[key]).forEach((kemenag) => {
          tafsirContainer.innerHTML += createTafsirAyahTemplate(
            srcKemenag[kemenag],
            tafsir[key][kemenag],
          );
        });
      } else {
        tafsirContainer.innerHTML += createTafsirAyahTemplate(srcTafsir[key], tafsir[key]);
      }
    });
  },
};

export default TafsirHandler;
